var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"size":"sm"},on:{"close":_vm.close}},[_c('div',{staticClass:"text-center text-sm"},[_c('div',[_vm._t("default",null,null,{ close: _vm.close, stop: _vm.stop, start: _vm.start, ambassadorship: _vm.ambassadorship })],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }